<template>
  <div class="req-id">
    <DpplTooltip
      tooltip-placement="left"
      :tooltip-offset="12"
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <p
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          {{ atsReqId }}
        </p>
      </template>
      <template #tooltip-content>
        <p class="content">
          {{ atsReqId }}
        </p>
      </template>
    </DpplTooltip>
  </div>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

defineProps({
  atsReqId: {
    type: String,
    default: '',
  },
});
</script>

<style lang="less" scoped>
.req-id {
  max-width: 100%;

  :deep(p) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
    font-weight: 500;

    &.content {
      line-height: 150%;
      color: @text-light;
      overflow: visible;
      white-space: normal;
    }
  }
}
</style>
